import React, { useState } from 'react';
import { FormDialog, InputField, MuiBox } from '@kis-technologies/kis-ui';
import { useStyles } from '../styled';

interface RefundOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (email: string) => void;
}

export const RefundOverlay = ({ isOpen, onClose, onConfirm }: RefundOverlayProps) => {
  const [form, setForm] = useState({ email: '' });
  const [validation, setValidation] = useState<{ email?: string }>({});

  const classes = useStyles()();

  const onInputChange = (field: string, e: React.ChangeEvent<HTMLInputElement>) => {
    setForm((prev) => ({
      ...prev,
      [field]: e.target.value
    }));
  };

  const validate = (field: string) => {
    if (field === 'email') {
      if (!form.email) {
        return '';
      }
      if (!/\S+@\S+\.\S+/.test(form.email)) {
        return 'Invalid email';
      }
    }
    return '';
  };

  const handleConfirm = () => {
    const error = validate('email');

    if (error) {
      setValidation({ email: error });
      return;
    }

    onConfirm(form.email.trim());
    onClose();
  };

  return (
    <FormDialog
      cancelButtonAction={onClose}
      confirmButtonAction={handleConfirm}
      cancelButtonText="Cancel"
      confirmButtonText="Refund"
      open={isOpen}
      title="Refund"
    >
      <MuiBox className={classes.formBox}>
        <InputField
          label="Email confirmation to"
          size="small"
          fullWidth
          value={form.email}
          onChange={(e) => onInputChange('email', e)}
          onBlur={() => validate('email')}
          helperText={validation.email}
          error={!!validation.email}
          sx={{ width: { xs: '262px', sm: '524px' } }}
        />
      </MuiBox>
    </FormDialog>
  );
};
